export const WEEE_FEEDBACK_FEATURE_NAME = 'weeeFeedback';
